/* eslint-disable */
import Swiper from '../libs/swiper.4.5.0.min'

$(function() {
  // Sliders

  function loadSliders() {
    var $slider = $('.b-slider');

    new Swiper($slider, {
      slidesPerView: 2,
      spaceBetween: IB.currentDevice === 'desktop' ? 50 : 35,
      navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
      },
      pagination: {
        el: '.slider-pagination',
      },
      preloadImages: false,
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      paginationClickable: true,
      breakpoints: {
        767:  {
          slidesPerView: 1
        }
      }
    });
  }

  // Responsive slider
  function loadResponsiveSliders() {
    if (IB.currentDevice !== 'desktop') {
      var $slider = $('.b-slider-responsive:not(.loaded)');

      new Swiper($slider.addClass('loaded'), {
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        },
        pagination: {
          el: '.slider-pagination',
        },
        preloadImages: false,
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        paginationClickable: true
      });

      responsiveClick($slider);
    }
  }

  // Mobile slider
  function loadMobileSliders() {
    var $slider = $('.b-slider-mobile:not(.loaded)');

    if (IB.currentDevice === 'mobile') {
      new Swiper($slider.addClass('loaded'), {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        },
        pagination: {
          el: '.slider-pagination',
        },
        preloadImages: false,
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        paginationClickable: true
      });
    }

    responsiveClick($slider);
  }

  function responsiveClick(slider) {
    slider.find('.video').click(function(event) {
      $(this).siblings().removeClass('clicked');
      $(this).addClass('clicked');
    });
  }

  function unloadResponsiveSliders() {
    // Remove style attributes from slides
    $('.b-slider-responsive.loaded').removeClass('loaded')
      .find('.swiper-wrapper, .swiper-slide').attr('style', '');
  }

  function unloadMobileSliders() {
    // Remove style attributes from slides
    $('.b-slider-mobile.loaded').removeClass('loaded')
      .find('.swiper-wrapper, .swiper-slide').attr('style', '');
  }

  function loadTopArticleSliders() {
    const MAX_ARTICLES_LIMIT = 3

    $('.js-top-slider-article').each(function() {
      if($(this).find('.js-swiper-wrapper').children().length <= MAX_ARTICLES_LIMIT) {
        $(this).find('.slider-prev, .slider-next').remove();
      }

      new Swiper($(this).addClass('loaded'), {
        slidesPerView: 3,
        navigation: {
          nextEl: '.slider-next',
          prevEl: '.slider-prev',
        },
        pagination: {
          el: '.slider-pagination',
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        preloadImages: false,
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        paginationClickable: true,
        watchOverflow: true,
      });
    })
    // responsiveClick($slider);
  }

  (function init() {
    loadSliders();
    loadResponsiveSliders();
    loadMobileSliders();
    loadTopArticleSliders();
  })();

  // Responsive events

  $(document).on('enter.desktop.mqbe', function() {
    unloadResponsiveSliders();
    unloadMobileSliders();
  });

  $(document).on('enter.tablet.mqbe', function() {
    loadResponsiveSliders();
    unloadMobileSliders();
  });

  $(document).on('enter.mobile.mqbe', function() {
    loadResponsiveSliders();
    loadMobileSliders();
  });
});
